<template>
    <Layout @filter="handleFilter">
        <div class="view-library">

            <section class="fieldset">

                <div class="cols">
                    <div class="col left">
                        <h3>Categories</h3>
                        <ul>
                            <li :class="{active:!activeCategory}" @click="setFilterCategory(false)">Tous <span
                                    class="badge">{{ plugins.length }}</span></li>
                            <li v-for="category in categoriesWithPlugins" :key="category.id"
                                :class="{active:activeCategory == category.id}" @click="setFilterCategory(category.id)">
                                {{ category.name }} <span class="badge">{{ category.count }}</span></li>
                        </ul>
                    </div>
                    <div class="col right plugins">
                        <div class="plugin-wrapper" v-for="plugin in filteredPlugins" :key="plugin.pluginId">
                            <PluginItem :infos="plugin" :provider="getProvider(plugin.providerId)"
                                        :category="getCategory(plugin.categoryId)"
                                        @click.native="showPluginDetails(plugin.pluginId)"></PluginItem>
                        </div>


                    </div>
                </div>

            </section>
        </div>
        <div slot="toolbarLeft">
            <router-link :to="{name:'pluginsSuggest'}" class="button white" :tag="'div'">
                <font-awesome-icon icon="comment-alt"></font-awesome-icon>
                Suggérer un connecteur
            </router-link>
            <!--<Btn class="white">
                <font-awesome-icon icon="comment-alt"></font-awesome-icon>
                Suggérer un plugin
            </Btn>-->
        </div>
    </Layout>
</template>

<script>
    //import Component from 'path/to/component'
    import _find from 'lodash/find'
    import _filter from 'lodash/filter'
    import {mapGetters, mapMutations, mapActions} from 'vuex'

    import Layout from '@l/List'

    import PluginItem from '@c/plugins/library/PluginItem'
    import PluginDetails from '@c/plugins/library/PluginDetails'


    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Layout,
            PluginItem
        },
        computed: {
            ...mapGetters({
                categories: 'Plugins/categories',
                plugins: 'Plugins/plugins',
                providers: 'Plugins/providers',
                configurations: 'Plugins/configurations'
            }),

            categoriesWithPlugins(){
                return this.categories.filter(item => {
                    return item.count > 0
                })
            },

            filteredPlugins() {

                let plugins = this.plugins

                if (this.activeCategory != null) {
                    plugins = _filter(plugins, item => {
                        return item.categoryId == this.activeCategory
                    })
                }
                if (this.activeFilter != null) {
                    plugins = _filter(plugins, item => {
                        return item.name.toLowerCase().indexOf(this.activeFilter.toLowerCase()) !== -1 || item.shortDesc.toLowerCase().indexOf(this.activeFilter.toLowerCase()) !== -1
                    })
                }
                return plugins
            }
        },
        created: function () {

        },
        data() {
            return {
                activeCategory: null,
                activeFilter: null
            }
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
                showModal: 'UI/showModal',
                setModalParams: 'UI/setModalParams',

            }),
            ...mapActions({
                fetchPlugins: 'Plugins/fetchPlugins',
                fetchConfigurations: 'Plugins/fetchConfigurations'
            }),

            handleFilter(query) {
                if (query != "") {
                    this.activeFilter = query
                }
                else {
                    this.activeFilter = null
                }


            },

            getProvider(providerId) {
                return _find(this.providers, {id: providerId})
            },

            getCategory(categoryId) {
                return _find(this.categories, {id: categoryId})
            },

            setFilterCategory(categoryId) {
                if (categoryId === false) {
                    this.activeCategory = null
                }
                else {
                    this.activeCategory = categoryId
                }
            },
            showPluginDetails(pluginId) {

                let plugin = _find(this.plugins,{pluginId:pluginId}),
                    provider = this.getProvider(plugin.providerId),
                    category = this.getCategory(plugin.categoryId),
                    configurations = this.configurations

                this.setModalParams({
                    component: PluginDetails,
                    class: 'plugin-modal',
                    width: '650px',
                    props: {
                        plugin,
                        provider,
                        category,
                        configurations
                    }
                })
                this.showModal();
            }
        },
        mounted: function () {

            this.$store.commit('UI/viewTitle', this.$i18n.t('plugins.titles.library'))
            this.$store.commit('UI/backAction', 'historyBack')

            this.fetchConfigurations()
                .then(() => {
                    this.fetchPlugins()
                        .then(() => {
                            this.showLoading(false);
                        })
                })

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .view-library {
        padding: 20px;
        height: 100%;

        .fieldset {
            height: 100%;
        }

        .cols {
            display: flex;
            height: 100%;

            .col {
                &.left {
                    flex: 0 0 200px;
                    padding-left: 0;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;

                        li {
                            cursor: pointer;
                            line-height: 24px;
                            transition-property: none;


                            .badge {
                                margin-top: 4px;
                                line-height: 14px;
                                padding: 2px 10px;
                                background-color: $main-color;
                                float: right;
                            }

                            &.active {
                                font-weight: $bold;
                            }
                        }
                    }
                }

                &.right {
                    flex: 1 1 100%;
                    height: 100%;
                    overflow-y: auto;
                    padding-right: 0;
                }
            }
        }

        .plugins {

            .plugin-wrapper {
                padding: 10px;
            }
        }
    }


</style>


// WEBPACK FOOTER //
// src/views/plugins/Library.vue